/**
 * Shared Spinner / loading-indicator component (design-system Phase 2).
 * Not yet imported by any existing page — safe to iterate on.
 *
 * Props:
 *  - label: text announced to screen readers and optionally shown inline
 *    (defaults to "Loading…" — pass the page's existing wording, e.g.
 *    "Loading invoices...", to preserve current copy per page)
 *  - size: 'sm' | 'md' | 'lg'
 *  - inline: renders inline (for use inside buttons/rows) instead of as a
 *    centered block
 */
export default function Spinner({ label = 'Loading…', size = 'md', inline = false, className = '' }) {
  return (
    <div
      className={`ds-spinner-wrap ${inline ? 'ds-spinner-inline' : 'ds-spinner-block'} ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className={`ds-spinner ds-spinner-${size}`} aria-hidden="true" />
      <span className={inline ? 'ds-sr-only' : 'ds-spinner-label'}>{label}</span>
    </div>
  );
}
